import {
  ITranslationContext,
  useTranslationContext,
} from "../context/TranslationContext";

export function useTranslation(): ITranslationContext<"microsite"> {
  return useTranslationContext();
}
